import * as Yup from 'yup';
const numberMax = 99999;

export const validationSchema = ({ t }) => {
  const hazmatMessages = {
    properShippingName: t('Proper Shipping Name is required'),
    unNumber: t('UN/NA is required'),
    hazMatClassId: t('HazMat Class is required'),
    hazMatPackingGroupId: t('Pkg Grp is required'),
    contactFirstName: t('Contact First Name is required'),
    contactLastName: t('Contact Last Name is required')
  };
  return Yup.object().shape({
    sku: Yup.string(),
    name: Yup.string().required(t('Name is required')),
    description: Yup.string(),
    freightInfo: Yup.object().shape({
      freightClassId: Yup.string(),
      nmfcItemCode: Yup.string(),
      nmfcSubCode: Yup.string()
    }),
    weightInfo: Yup.object().shape({
      weight: Yup.number()
        .min(0.01, t('Weight should be greater than 0'))
        .max(numberMax, `${t('Weight should be smaller than')} ${numberMax}`)
        .decimals(2, t('Weight exceeded 2 decimal places'))
        .nullable()
    }),
    valueInfo: Yup.object().shape({
      value: Yup.number()
        .min(1, t('Value should be equal or greather than 1'))
        .max(numberMax, `${t('Value should be smaller than')} ${numberMax}`)
        .decimals(2, t('Value exceeded 2 decimal places'))
        .nullable()
    }),
    packageTypeId: Yup.string().nullable(),
    pieceCount: Yup.number()
      .integer(t('Piece count must be an integer'))
      .min(1, t('Piece Count should be equal or greather than 1'))
      .max(numberMax, `${t('Piece Count should be smaller than')} ${numberMax}`)
      .nullable(),
    isHazMat: Yup.boolean(),
    hazMat: Yup.object().when('isHazMat', {
      is: true,
      then: Yup.object({
        properShippingName: Yup.string()
          .required(hazmatMessages.properShippingName)
          .typeError(hazmatMessages.properShippingName),
        unNumber: Yup.string()
          .typeError(hazmatMessages.unNumber)
          .required(hazmatMessages.unNumber),
        hazMatClassId: Yup.string()
          .typeError(hazmatMessages.hazMatClassId)
          .required(hazmatMessages.hazMatClassId),
        hazMatPackingGroupId: Yup.string()
          .typeError(hazmatMessages.hazMatPackingGroupId)
          .required(hazmatMessages.hazMatPackingGroupId),
        contactFirstName: Yup.string()
          .typeError(hazmatMessages.contactFirstName)
          .required(hazmatMessages.contactFirstName),
        contactLastName: Yup.string()
          .typeError(hazmatMessages.contactLastName)
          .required(hazmatMessages.contactLastName),
        contactPhone: Yup.string()
          .phone(t('Phone Number is invalid'))
          .typeError(t('Phone number is required'))
          .required(t('Phone number is required'))
      })
    })
  });
};
export default validationSchema;
